import { AgTechHttpRequest } from "@agtech/core/data/actions/AgTechHttpRequests";
import { useAgTechApiDownloadRequest } from "@agtech/core/data/http/AgTechApiGetRequests";

export type ReportFormat = 'Pdf' | 'Excel' | 'Csv';

const reportExtensions: Record<ReportFormat, string> = {
    Pdf: 'pdf',
    Excel: 'xlsx',
    Csv: 'csv'
};

export type ExportOnlyFormat = 'Excel' | 'Csv';

const exportExtensions: Record<ExportOnlyFormat, string> = {
    Excel: 'xlsx',
    Csv: 'csv'
};

export const useReportDataGetAfterSaleReportRequest = (): AgTechHttpRequest<{ saleId: number, format: ReportFormat }, any> => {
    let afterSaleReportRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await afterSaleReportRequest.download({
            path: `Sales/GetAfterSaleReportDocument/${props.data.saleId}?format=${props.data.format}`,
            fileNameWithExtension: `AfterSaleReport_${new Date().toDateString()}.${reportExtensions[props.data.format]}`
        })
    }
}

export const useReportDataGetOutstandingCreditsReportRequest = (): AgTechHttpRequest<{ format: ReportFormat }, any> => {
    let outstandingCreditsRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await outstandingCreditsRequest.download({
            path: `ContactCredit/GetOutstandingContactCreditsReport?format=${props.data.format}`,
            fileNameWithExtension: `OutstandingCredits_${new Date().toDateString()}.${reportExtensions[props.data.format]}`
        })
    }
}

export const useReportDataGetLotOrderReportRequest = (): AgTechHttpRequest<number, any> => {
    let lotOrderRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props =>  await lotOrderRequest.download({
            path: 'Lot/GetSaleOrderDocument/' + props.data,
            fileNameWithExtension: `LotSaleOrder_${new Date().toDateString()}.pdf`
        })
    }
}

export type LotsByPurchaserReportFormat = ReportFormat;

export const useReportDataGetLotsByPurchaserReportRequest = (): AgTechHttpRequest<{ saleId: number, format: LotsByPurchaserReportFormat }, any> => {
    let lotsByPurchaserRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await lotsByPurchaserRequest.download({
            path: `Sales/GetLotsByPurchasersReport/${props.data.saleId}?format=${props.data.format}`,
            fileNameWithExtension: `LotsByPurchaser_${new Date().toDateString()}.${reportExtensions[props.data.format]}`
        })
    }
}

export const useReportDataGetLotsPurchasedInOrderReportRequest = (): AgTechHttpRequest<{ saleId: number, format: ReportFormat }, any> => {
    let lotsPurchasedInOrderRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await lotsPurchasedInOrderRequest.download({
            path: `Sales/GetLotsPurchasedInOrderReport/${props.data.saleId}?format=${props.data.format}`,
            fileNameWithExtension: `LotsInOrderByPurchaser_${new Date().toDateString()}.${reportExtensions[props.data.format]}`
        })
    }
}

export const useReportDateGetUnpaidInvoicesRequest = (): AgTechHttpRequest<{ saleId: number, format: ReportFormat }, any> => {
    let unpaidInvoicesRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await unpaidInvoicesRequest.download({
            path: `Invoice/GetUnpaidInvoiceReport/${props.data.saleId}?format=${props.data.format}`,
            fileNameWithExtension: `UnpaidInvoicesReport_${new Date().toDateString()}.${reportExtensions[props.data.format]}`
        })
    }
}

export const useBidderDataExportRequest = (): AgTechHttpRequest<{ saleId: number, format: ExportOnlyFormat }, any> => {
    let bidderExportRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await bidderExportRequest.download({
            path: `Bidder/Export/${props.data.saleId}?format=${props.data.format}`,
            fileNameWithExtension: `Bidders_${new Date().toDateString()}.${exportExtensions[props.data.format]}`
        })
    }
}

export const useSoldLotDataExportRequest = (): AgTechHttpRequest<{ saleId: number, format: ExportOnlyFormat }, any> => {
    let soldLotExportRequest = useAgTechApiDownloadRequest();

    return {
        execute: async props => await soldLotExportRequest.download({
            path: `Lot/ExportSoldLots/${props.data.saleId}?format=${props.data.format}`,
            fileNameWithExtension: `SoldLots_${new Date().toDateString()}.${exportExtensions[props.data.format]}`
        })
    }
}
